<div class="football-card">
  <div class="icon">
    <img src="/assets/images/football-icon.svg" alt="">
  </div>

  <div class="cta">
    <p>GoArmy Edge Football</p>
    <a angulartics2On="click" angularticsCategory="Internal Navigation" angularticsEvent="Home Content" [angularticsProperties]="{ label: 'Go to Football' }" routerLink="/football" class="button"><img src="assets/images/arrow.svg" alt="Go to Football"></a>
  </div>

  <div class="main">
    <img src="/assets/images/home/football-card-img.jpg" alt="GoArmy Edge Football Screenshot">
  </div>
</div>

<div class="soccer-card">
  <div class="icon">
    <img src="/assets/images/soccer-icon.svg" alt="">
  </div>

  <div class="cta">
    <p>GoArmy Edge Soccer</p>
    <a angulartics2On="click" angularticsCategory="Internal Navigation" angularticsEvent="Home Content" [angularticsProperties]="{ label: 'Go to Soccer' }" routerLink="/soccer" class="button"><img src="/assets/images/arrow.svg" alt="Go to Soccer"></a>
  </div>

  <div class="main">
    <img src="/assets/images/home/soccer-card-img.jpg" alt="GoArmy Edge Soccer Screenshot">
  </div>
</div>

<div class="fitness-card">
  <div class="icon">
    <img src="/assets/images/fitness/fitness-icon.svg" alt="">
  </div>

  <div class="cta">
    <p>GoArmy Edge Fitness</p>
    <a angulartics2On="click" angularticsCategory="Internal Navigation" angularticsEvent="Home Content" [angularticsProperties]="{ label: 'Go to Fitness' }" routerLink="/fitness" class="button"><img src="/assets/images/arrow.svg" alt="Go to Fitness"></a>
  </div>

  <div class="main">
    <div class="screenshots">
      <img src="/assets/images/fitness/lunge.png" alt="GoArmy Edge Fitness Screenshot">
      <img src="/assets/images/fitness/bb-close-grip.png" alt="GoArmy Edge Fitness Screenshot">
    </div>
  </div>
</div>
